/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type UpsertConfigRequestBody2 = {
  /**
   * Secret credential values keyed by field key. Stored encrypted; never returned on reads. Omit to keep the existing secrets.
   */
  credentials?: { [k: string]: string } | undefined;
  /**
   * Whether the integration should be active.
   */
  enabled: boolean;
  /**
   * Provider identifier (e.g. jamf, kandji, drata, vanta).
   */
  provider: string;
  /**
   * Non-secret settings values keyed by field key. Merged per key with the stored settings: omitted keys keep their stored values.
   */
  settings?: { [k: string]: string } | undefined;
};

/** @internal */
export type UpsertConfigRequestBody2$Outbound = {
  credentials?: { [k: string]: string } | undefined;
  enabled: boolean;
  provider: string;
  settings?: { [k: string]: string } | undefined;
};

/** @internal */
export const UpsertConfigRequestBody2$outboundSchema: z.ZodMiniType<
  UpsertConfigRequestBody2$Outbound,
  UpsertConfigRequestBody2
> = z.object({
  credentials: z.optional(z.record(z.string(), z.string())),
  enabled: z.boolean(),
  provider: z.string(),
  settings: z.optional(z.record(z.string(), z.string())),
});

export function upsertConfigRequestBody2ToJSON(
  upsertConfigRequestBody2: UpsertConfigRequestBody2,
): string {
  return JSON.stringify(
    UpsertConfigRequestBody2$outboundSchema.parse(upsertConfigRequestBody2),
  );
}
